export { default as DesktopView } from './DesktopView'
export { default as MobileView } from './MobileView'
export { default as TabletView } from './TabletView'
export { default as PageView } from './PageView'
export { default as PrintView } from './PrintView'
